// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"f40cdad8","815":"567ed966"}[chunkId] + ".chunk.js";
};